const Search = function() {

    const getRecentSearches = () => {
        let recent_searches_str = Generic.jsCookies.getItem('recent_searches') || '';
        return recent_searches_str ? JSON.parse(recent_searches_str) : [];
    };

    const saveRecentSearches = (recent_searches) => {
        Generic.jsCookies.setItem(
            'recent_searches',
            JSON.stringify(recent_searches),
            3600 * 24 * 7,
            '/'
        );
        renderRecentSearches(recent_searches);
    };

    const addRecentSearch = (val) => {
        let recent_searches = getRecentSearches();
        if (recent_searches.length && val == recent_searches[0]) {
            return;
        }
        let valEscaped = $('<div/>').text(val).html();
        recent_searches.unshift(valEscaped);
        recent_searches.length = Math.min(recent_searches.length, 3);
        saveRecentSearches(recent_searches);
    };

    const removeRecentSearch = (index) => {
        if (index < 0 || index > 2) {
            return;
        }
        let recent_searches = getRecentSearches();
        if (index > recent_searches.length - 1) {
            return;
        }
        recent_searches.splice(index, 1);
        saveRecentSearches(recent_searches);
    };

    const renderRecentSearches = (recent_searches_arr = null) => {
        let recent_searches = recent_searches_arr || getRecentSearches();
        if (!(recent_searches && recent_searches.length)) {
            $('#recent_searches_content').hide();
            return;
        }
        let html = '<h4 class="search-n__title">Πρόσφατες Αναζητήσεις</h4>';
        for (let ix = 0; ix < recent_searches.length; ix++) {
            let recent_search_escaped = $('<div/>').text(recent_searches[ix]).html();
            if (recent_search_escaped == 'undefined') { // an older bug added this as recent search in some cases
                continue;
            }
            html += `
                <a href="javscript:void(0);" class="search-n__item search-n__item--history ii__search_item ii__recent_search_item"
                data-term="${recent_search_escaped}">
                    <i class="icon fal fa-clock"></i>
                    <span>${recent_search_escaped}</span>
                    <button class="btn-clean search__history_btn ii__remove_recent_search_btn" data-index="${ix}" type="button">
                        <svg role="img" class="icon-svg icon-close"><use xlink:href="/static/icons/icons.svg?js_asset=1#icon-close"></use></svg>
                    </button>
                </a>
            `;
        }
        $('#recent_searches_content').html(html).show();
    };

    const handleSearchResultVisit = (result_elem) => {
        let term = (String(result_elem.data('term')) || '').trim();
        if (term) {
            addRecentSearch(term);
        }
    };

    const handleRecentSearchSelection = (recent_search_elem) => {
        let term = (String(recent_search_elem.data('term')) || '').trim();
        if (!term) {
            return;
        }
        let term_escaped = $('<div/>').text(term).html(),
            global_search = $('#globalsearch')
        ;
        global_search.val(term_escaped);
        handleSearch(global_search);
        global_search.focus();
    };

    const showSearch = () => {
        let global_search = $('#globalsearch');
        if (Generic.mobile) {
            $('#search_form').addClass('search-n--typing');
            $('.menu').addClass('menu-black');
            $('.ii__sticky_footer').hide();
        } else {
            $('#search_form').addClass('search-n--focus search-n--on');
        }
        if (global_search.val()) {
            $('#default_search_content').hide();
            if (!Generic.mobile) {
                global_search.parent().addClass('search-n--typing');
            }
        } else {
            $('#default_search_content').show();
        }
        global_search.focus();
    };

    const closeSearch = () => {
        $('#search_form').removeClass('search-n--typing search-n--on search-n--focus');
        $('.page').removeClass('ii__search_overlay');
    };

    const handleSearch = (global_search) => {
        let val = global_search.val();

        if (val == '') {
            Search.resetSearch();
            return;
        }

        $(this).parent().addClass('search-n--on search-n--typing');
        $('#default_search_content').hide();
        $('#results_content').html('');

        Ajax.autocompleteSearch(val, (res) => {
            if (!(res.success == 'ok' && res.results)) {
                return;
            }
            if (!res.results.length) {
                $('#results_content').html(
                    '<div class="search-n__item"><span>Δεν βρέθηκαν αποτελέσματα.</span></div>'
                ).show();
                return;
            }
            let currentCategory = '',
                html = '',
                currentVal = String(global_search.val()).trim()
            ;
            for (const result of res.results) {
                let term = String(result.value).trim();
                if (term != currentVal) { // make sure the response matches the current search term
                    return;
                }
                if (result.category != currentCategory) {
                    html += `<h4 class="search-n__title">${result.category}</h4>`;
                    currentCategory = result.category;
                }
                if (result.category == 'Αγώνες') {
                    html += `
                        <a href="${result.url}" class="search-n__item search-n__item--match ii__search_item" data-term="${term}">
                            <div class="search-n__date">
                                <span>${result.match_date}</span>
                                <span>${result.match_year}</span>
                            </div>
                            <div>
                                <div class="search-n__team mb-2">
                                    ${result.team_home_logo_img_tag}
                                    <span>${result.team_home}</span>
                                </div>
                                <div class="search-n__team">
                                    ${result.team_away_logo_img_tag}
                                    <span>${result.team_away}</span>
                                </div>
                            </div>
                            ${result.score && result.score.length ? `
                            <div class="search-n__results">
                                <span>${result.score[0]}</span>
                                <span>${result.score[1]}</span>
                            </div>
                            ` : ''}
                        </a>
                    `;
                } else if (result.category == 'Ειδήσεις') {
                    if (Generic.mobile) {
                        html += `
                            <a href="${result.url}" class="search-n__item ii__search_item search-n__item--article" data-term="${term}">
                                <div class="search-n-article_content">
                                    <div class="search-n-article_info">
                                        <span class="search-n-article_date">${result.publish_date}</span>
                                    </div>
                                    <span>${result.label}</span>
                                </div>
                                ${result.img_tag}
                            </a>
                        `;
                    } else {
                        html += `
                            <a href="${result.url}" class="search-n__item ii__search_item search-n__item--article" data-term="${term}">
                                ${result.img_tag}
                                <span>${result.label}</span>
                            </a>
                        `;
                    }
                } else {
                    html += `
                        <a href="${result.url}" class="search-n__item ii__search_item" data-term="${term}">
                            ${result.img_tag}
                            <span>${result.label}</span>
                        </a>
                    `;
                }
            }
            $('#results_content').html(html).show();
        });
    };

    return {
        init: () => {
            if ($('#globalsearch').length == 0) {
                return;
            }
            renderRecentSearches();

            $('#globalsearch, #search_btn').click(showSearch);

            $('#globalsearch').keydown(function(ev) {
                if (ev.key == 'Enter') {
                    ev.preventDefault();
                } else if (ev.key == 'Escape') {
                    if ($(this).val()) {
                        Search.resetSearch();
                    } else {
                        closeSearch();
                    }
                } else if (ev.key == 'ArrowDown') {
                    $(this).parent().find('.ii__search_item:visible').first().focus();
                }
            });

            $('#globalsearch').on('input', function() {
                let global_search = $(this);
                handleSearch(global_search);
            });

            $('#search_reset_btn').click(() => {
                Search.resetSearch();
            });

            $('#search_form').click(function(e) {
                if (Generic.mobile) {
                    return;
                }
                e.stopPropagation();
                $('.page').addClass('ii__search_overlay');
            });

            if (!Generic.mobile) {
                $(document).on('click', '.ii__search_overlay', function(e) {
                    e.stopPropagation();
                    closeSearch();
                });
            }

            $('.ii__search_content').on('keydown', '.ii__search_item', function(ev) {
                if (ev.key == 'ArrowDown') {
                    let next_elem = $(this).nextAll('.ii__search_item:visible').first();
                    if (!next_elem.length && !$(this).hasClass('ii__recent_search_item')) {
                        next_elem = $('.ii__recent_search_item:visible').first();
                    }
                    next_elem.focus();
                } else if (ev.key == 'ArrowUp') {
                    let prev_elem = $(this).prevAll('.ii__search_item:visible').first();
                    if (!prev_elem.length && $(this).hasClass('ii__recent_search_item')) {
                        prev_elem = $('#pinned_results_content').find('.ii__search_item:visible').last();
                    }
                    if (!prev_elem.length) {
                        prev_elem = $('#globalsearch');
                    }
                    prev_elem.focus();
                } else if (ev.key == 'Escape') {
                    let global_search = $('#globalsearch');
                    if (global_search.val()) {
                        global_search.val('').focus();
                        Search.resetSearch();
                    } else {
                        closeSearch();
                    }
                } else if (ev.key == 'Enter') {
                    if ($(this).hasClass('ii__recent_search_item')) {
                        ev.preventDefault();
                        handleRecentSearchSelection($(this));
                    } else {
                        handleSearchResultVisit($(this));
                    }
                }
            });

            $('.ii__search_content').on('click', '.ii__search_item', function(ev) {
                if ($(this).hasClass('ii__recent_search_item')) {
                    ev.preventDefault();
                    handleRecentSearchSelection($(this));
                } else {
                    handleSearchResultVisit($(this));
                }
            });

            $('#recent_searches_content').on('click', '.ii__remove_recent_search_btn', function(ev) {
                ev.preventDefault();
                removeRecentSearch(parseInt($(this).data('index')));
            });
        },

        resetSearch: (show_sticky_footer = true) => {
            $('#search_form').removeClass('search-n--typing');
            $('#default_search_content').show();
            $('#results_content').hide().html('');
            if (Generic.mobile) {
                $('.menu').removeClass('menu-black');
                if (show_sticky_footer) {
                    $('.ii__sticky_footer').show();
                }
            }
        }
    };
}();
